export default __webpack_public_path__ + "static/media/formschon-gold.ff8a457a.png";